import React from 'react';
import { StyledPrevArrowWrapper } from 'src/features/white-labels/techcontemporary/app/components/banner/styles';

export const PrevArrow = (props: any) => {
    const { onClick } = props;
    return (
        <StyledPrevArrowWrapper onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                    d="M14.6189 6.45203C14.9606 6.11032 14.9606 5.5563 14.6189 5.21459C14.2772 4.87289 13.7232 4.87289 13.3814 5.21459L9.29811 9.29793L5.21478 13.3813C5.04392 13.5521 4.9585 13.776 4.9585 14C4.9585 14.1186 4.98211 14.2317 5.02489 14.3349C5.06727 14.4374 5.12995 14.5334 5.21292 14.6168L5.21478 14.6187"
                    fill="#F5F7F6"
                />
                <path
                    d="M5.21478 14.6187L13.3814 22.7854C13.7232 23.1271 14.2772 23.1271 14.6189 22.7854C14.9606 22.4437 14.9606 21.8896 14.6189 21.5479L7.94593 14.875H22.1668C22.6501 14.875 23.0418 14.4832 23.0418 14C23.0418 13.5167 22.6501 13.125 22.1668 13.125H7.94593L14.6189 6.45203"
                    fill="#F5F7F6"
                />
            </svg>
        </StyledPrevArrowWrapper>
    );
};